import { instance } from './ApiRequest';
import {
    LANGUAGE_CONFIG_GET_PORTAL_LANGUAGE_CONFIG, LANGUAGE_CONFIG_UPDATE_PORTAL_LANGUAGE_CONFIG,
    LANGUAGE_CONFIG_GET_LANGUAGE_MASTER_LIST, LANGUAGE_CONFIG_GET_SELECTABLE_REGIONAL_LANGUAGES,
    LANGUAGE_CONFIG_UPDATE_LANGUAGE_ACTIVE
} from 'constants/constants';

// Phase C.2 (Enterprise Language Configuration Foundation) — a dedicated module for this new backend
// surface, following the same "one small module per related API surface" convention PublicationService.js
// and EnterpriseOpsService.js established, rather than folding these into the large legacy AdminService.js.
let _LanguageConfigService = {
    // Candidate-facing (and admin-facing), anonymous.
    async getPortalLanguageConfig() {
        return await instance.get(LANGUAGE_CONFIG_GET_PORTAL_LANGUAGE_CONFIG);
    },

    // Admin-facing, Global-Admin-gated on the backend.
    async updatePortalLanguageConfig(model) {
        return await instance.post(LANGUAGE_CONFIG_UPDATE_PORTAL_LANGUAGE_CONFIG, model);
    },
    async getLanguageMasterList() {
        return await instance.get(LANGUAGE_CONFIG_GET_LANGUAGE_MASTER_LIST);
    },
    async getSelectableRegionalLanguages() {
        return await instance.get(LANGUAGE_CONFIG_GET_SELECTABLE_REGIONAL_LANGUAGES);
    },
    async updateLanguageActive(id, isActive) {
        return await instance.post(LANGUAGE_CONFIG_UPDATE_LANGUAGE_ACTIVE + "?id=" + id + "&isActive=" + isActive);
    }
};

export default _LanguageConfigService;
